import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@material-ui/core';
import {
  highRiskDna,
  noRiskComorbidity,
  moderateRiskDna,
} from 'on_web/assets/imageList';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { LOW_RISK_COLOR, SEVERE_RISK_COLOR, HIGH_RISK_COLOR } from 'colours';

/**
 * Component displaying the overall risk for blood type group.
 */
export default function BloodTypeAssessmentCard(props) {
  const { t } = useTranslation();
  const { isDesktop } = props;

  const useStyles = makeStyles(theme => ({
    text: {
      fontSize: '21px',
      fontFamily: 'Museo',
      fontWeight: 'bold',
      textAlign: isDesktop ? 'left' : 'center',
    },
    riskLevel: {
      fontSize: '21px',
      fontFamily: 'Museo',
      fontWeight: 'bold',
      marginTop: isDesktop ? '0' : '24px',
    },
    type: {
      fontSize: '50px',
      fontFamily: 'Museo',
      fontWeight: 'bold',
      color:
        props.riskLevel === 0
          ? LOW_RISK_COLOR
          : props.riskLevel === 1
          ? SEVERE_RISK_COLOR
          : HIGH_RISK_COLOR,
    },
  }));

  const classes = useStyles();
  return (
    <Box
      style={{
        paddingLeft: '20px',
        paddingRight: '20px',
        marginTop: '14px',
      }}
    >
      <Grid
        container
        direction={props.isDesktop ? 'row' : 'column'}
        justify="center"
        alignItems="center"
      >
        <Grid item xs={isDesktop ? 2 : 12}>
          <Grid
            container
            spacing={2}
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item>
              <Box
                className={classes.type}
                display="flex"
                justifyContent="center"
                textAlign="center"
              >
                {props.type}
              </Box>
            </Grid>
            <Grid item>
              <Box justifyContent="center">
                <img
                  alt="risk level illustration"
                  src={
                    props.riskLevel === 0
                      ? noRiskComorbidity
                      : props.riskLevel === 1
                      ? moderateRiskDna
                      : highRiskDna
                  }
                  width={70}
                  height={55}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={isDesktop ? 4 : 12}
          style={{ marginRight: '10px', marginTop: '24px' }}
        >
          <Box className={classes.text}>{props.typeDescription}</Box>
        </Grid>

        <Grid
          item
          xs={isDesktop ? 6 : 12}
          style={{
            marginRight: '10px',
            marginTop: isDesktop ? '12px' : '24px',
          }}
        >
          <Box className={classes.text}>{props.riskDescription}</Box>
        </Grid>
      </Grid>
    </Box>
  );
}

BloodTypeAssessmentCard.propTypes = {
  riskLevel: PropTypes.number.isRequired,

  type: PropTypes.string.isRequired,

  typeDescription: PropTypes.string.isRequired,

  riskDescription: PropTypes.string.isRequired,

  isDesktop: PropTypes.bool.isRequired,
};
